import { render, staticRenderFns } from "./indexcopy.vue?vue&type=template&id=705b432e&scoped=true"
import script from "./indexcopy.vue?vue&type=script&lang=js"
export * from "./indexcopy.vue?vue&type=script&lang=js"
import style0 from "./indexcopy.vue?vue&type=style&index=0&id=705b432e&prod&rel=stylesheet%2Fscss&lang=scss"
import style1 from "./indexcopy.vue?vue&type=style&index=1&id=705b432e&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705b432e",
  null
  
)

export default component.exports